export default __webpack_public_path__ + "static/media/java.d219f1fe.png";